// extracted by mini-css-extract-plugin
export default {"productGallery":"CE-z","inQuickShop":"DE-z"};